export const checkMarkWithSectionTotal = async (ptDetails: any[], subDetails: any[]) => {
  try {
    console.log(ptDetails, 'pt details', subDetails, 'details')
    //checking product details is there
    if (ptDetails.length === 0 || !ptDetails[0]) {
      console.error('ptDetails array is empty')
      return { status: false, message: 'Unable to find the section details' }
    }

    //product taking the product details
    const ptDetail = ptDetails[0]
    console.log(ptDetail,'ptDetails')
    const totalProductMark = Number(ptDetail.total_marks)
    const totalProductQuestions = Number(ptDetail.total_questions)
    let allSectionTotalMark = 0
    let allSectionTotalQuestion = 0

    //if there is no section in product
    if (!ptDetail.sections || ptDetail.sections.length === 0) {
      return { status: false, message: 'Unable to find all section details., Please try after some time' }
    }
    //looping each section in the product
    for (let j = 0; j < ptDetail.sections.length; j++) {
      const ptSection = ptDetail.sections[j]
     
      //setting total marks and totalQuestions = 0
      let totalMarks = 0
      let totalQuestions = 0
      //finding the total of each sections
      const ptMarks = Number(ptSection.marks)
      const ptNoOfQuestions = Number(ptSection.no_of_questions)

      //finding the subsections which is from same section
      const matchedSubDetails =await subDetails.filter((subDetail: any) => subDetail.section_id === ptSection.section_id)
      console.log(matchedSubDetails,'matchedSubDetails')
      if (matchedSubDetails.length > 0) {
        for (let k = 0; k < matchedSubDetails.length; k++) {
          const subDetail = matchedSubDetails[k]
          totalQuestions += Number(subDetail.no_of_questions)
          totalMarks += Number(subDetail.mark_per_question) * Number(subDetail.no_of_questions)
        }
        if (totalQuestions !== ptNoOfQuestions || totalMarks !== ptMarks) {
          return { status: false, flag: 2, message: 'Marks or questions with sections is not matching Please check the details before uploading...' }
        } else {
          allSectionTotalMark += totalMarks
          allSectionTotalQuestion += totalQuestions
        }
      } else {
        console.log(`No matching subDetail found for section ${ptSection.section_id}`)
        return { status: false, message: `No matching subDetail found for section ${ptSection.section_id}` }
      }
    }

    if (totalProductMark === allSectionTotalMark && totalProductQuestions === allSectionTotalQuestion) {
      return { status: true, flag: 1, message: 'Marks and questions match' }
    } else {
      return { status: false, flag: 0, message: 'Marks not match with total product mark or total product questions' }
    }
  } catch (err) {
    console.error('Error in checkMarkWithSectionTotal:', err)
    return { status: false, message: 'Something went wrong, Please try again after sometimes' }
  }
}
